const articlePathPattern = /\/articles\/(\d+)(?:-|\/|$)/;

export const getHelpArticleId = (href: string, helpCenterOrigin: string): string | undefined => {
  if (!URL.canParse(href)) {
    return undefined;
  }

  const url = new URL(href);
  return url.origin === helpCenterOrigin ? articlePathPattern.exec(url.pathname)?.[1] : undefined;
};
